import { render, staticRenderFns } from "./MyRouter.vue?vue&type=template&id=25c21131&"
import script from "./MyRouter.vue?vue&type=script&lang=ts&"
export * from "./MyRouter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports